import React, { useState } from "react";
import Breadcrumb from "../../../components/common/Breadcrumbs";
import TeamForm from "./TeamForm";

const CreateTeam = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/" },
        { content: "Teams", url: "/teams" },
        { content: "Add Team", url: "/teams/create" },
    ]);


    return (
        <>
            <div className="px-4 py-2">
                <TeamForm crumbs={crumbs} title={"Add Team"} btnText={"Create"}/>
            </div>
        </>
    )
}
export default CreateTeam;